import React from 'react';
import { Link } from "react-router-dom";
import CustomLink from "../common/CustomLink";
import { connect } from "react-redux";
import * as d from "../../reducers/domainReducer";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import FeatureDisabled from '../common/FeatureDisabled';
import MedicationsBanner from "./MedicationsBanner";

class PharmacyHeader extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.PharmacyHeader.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { currentPharmacyUser, rxDown, hasPharmacyLogin } = this.props;
        const enableNewMenu = window.serverData.data.enableNewMenu;
        const yourPharmacy = currentPharmacyUser && currentPharmacyUser.firstName ? currentPharmacyUser.firstName + "'s Pharmacy" : 'Your Pharmacy';
        let heading = '';
        let subHeading = '';
        let pathname = '';
        let prefix = '/';
        let homePage = { to: { pathname: "/" } };
        let hasPharmacyHome = !rxDown && (hasPharmacyLogin || currentPharmacyUser);

        if (typeof window !== 'undefined') {
            pathname = window.location.pathname.toLowerCase();
            if (typeof window !== 'undefined' && window.serverData.data.bundle !== 'pharmacy' && window.location.href.toLowerCase().indexOf('localhost') > -1) {
                prefix = '/pharmacy';
            }
        }

        const secondSlashIndex = pathname.indexOf('/', 1);
        if (secondSlashIndex > -1) {
            pathname = pathname.substring(0, secondSlashIndex);
        }

        switch (pathname) {
            case prefix + 'rxtransfer':
            case prefix + 'bswtransfer':
            case prefix + 'nonbswtransfer':
                heading = 'Transfer a Prescription';
                break;
            case prefix + 'rxrefill': heading = 'Order a Refill'; break;
            case prefix + 'rxlist': heading = 'Prescriptions'; break;
            case prefix + 'rxdetail':
                heading = 'Prescription Detail';
                // subHeading = <span><span className="heading-divider">{' / '}</span><Link to={{ pathname: prefix + 'rxList' }}>All Prescriptions</Link></span>;
                break;
            case prefix + 'findpharmacy': heading = 'Find a Pharmacy'; break;
            case prefix + 'pickupdetails': heading = 'Pickup Details'; break;
        }

        const content = heading === '' ?
            <h1 className="page-heading">{yourPharmacy}</h1> :
            (<h1 className="page-heading">
                {!enableNewMenu &&
                    <><Link to={{ pathname: prefix === '/' ? '/rxHome' : '/pharmacy' }}>{yourPharmacy}</Link>{subHeading}<span className="heading-divider">{' / '}</span></>
                }
                {heading}
            </h1>);

        const headerContent = (heading === 'Transfer a Prescription' || heading === 'Order a Refill') ?
            (<div className="modal-header-container">
                <div className="row">
                    <div className="col-12">                  
                        {
                            hasPharmacyHome ?
                                <Link to={{ pathname: prefix === '/' ? '/rxHome' : '/pharmacy' }} className="modal-header-close"><span className="icon-close" /></Link>
                                : <CustomLink linkProps={{ ...homePage, className: "modal-header-close" }}><span className="icon-close" /></CustomLink>
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="modal-header-title truncate">{heading}</div>
                    </div>
                </div>
            </div>) : '';

        return !rxDown
            ? <div className="col-12 page-heading-container">
                <MedicationsBanner />
                {content}
                {headerContent}
            </div>
            : <FeatureDisabled />;
    }
}

const mapStateToProps = (state) => {

    return {
        rxDown: state.common.rxDown,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu)
    };
};

export default connect(mapStateToProps)(PharmacyHeader);